import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import ICtaBox from '../../../interfaces/elements/ctaBox';
import * as StyledCtaBox from './ctaBox.styles';

interface Props {
	box: ICtaBox;
}

const CtaBox: FC<Props> = ({ box }) => {
	return (
		<StyledCtaBox.Wrapper>
			<StyledCtaBox.WrapperLink
				to={box.Values.Link?.Url}
				href={box.Values.Link?.Url}
				as={box.Values.Link?.Type === 2 ? 'a' : Link}
				target={box.Values.Link?.Target}>
				<StyledCtaBox.Top>{box.Values.Text}</StyledCtaBox.Top>
				<StyledCtaBox.Image useCrop={false} image={box.Values.Image.Src}></StyledCtaBox.Image>
			</StyledCtaBox.WrapperLink>
			<StyledCtaBox.ImageText>
				<div>{box.Values.Text}</div>
				<StyledCtaBox.ImageLinkText>{box.Values.LinkText}</StyledCtaBox.ImageLinkText>
			</StyledCtaBox.ImageText>
		</StyledCtaBox.Wrapper>
	);
};

export default CtaBox;
